import React from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { translations } from "../i18n/translations";

export default function Amenities() {
  const { t } = useLanguage();
  const tx = translations.amenities;

  return (
    <section id="amenidades" className="bg-[#EDE6D7] py-24 lg:py-36">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 lg:mb-20">
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="h-[1px] w-10 bg-[#9C8456]" />
            <span
              className="text-[#9C8456] text-[11px] tracking-[0.45em] uppercase"
              style={{ fontFamily: "'Jost', sans-serif" }}
            >
              {t(tx.eyebrow)}
            </span>
            <div className="h-[1px] w-10 bg-[#9C8456]" />
          </div>
          <h2
            className="text-[#2A2A28] text-[34px] sm:text-[48px] lg:text-[58px] leading-[1.08] max-w-3xl mx-auto"
            style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300 }}
          >
            {t(tx.title1)} <em className="italic">{t(tx.title2)}</em>
          </h2>
          <p
            className="text-[#3a3a36] text-[15px] lg:text-[17px] leading-[1.85] mt-7 max-w-2xl mx-auto"
            style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
          >
            {t(tx.intro)}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {tx.items.map((item) => (
            <div
              key={item.key}
              className="group bg-[#F5F0E8] overflow-hidden border border-[#D4CBB8]/40 hover:border-[#9C8456] transition-colors duration-500"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-[#D4CBB8]">
                <img
                  src={item.image}
                  alt={t(item.name)}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1500ms]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-transparent to-transparent" />
              </div>
              <div className="p-7 lg:p-8">
                <h3
                  className="text-[#2A2A28] text-[22px] lg:text-[26px] leading-tight mb-3"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
                >
                  {t(item.name)}
                </h3>
                <div className="h-[1px] w-10 bg-[#9C8456] mb-3" />
                <p
                  className="text-[#6B6760] text-[13px] lg:text-[14px] leading-[1.65]"
                  style={{ fontFamily: "'Jost', sans-serif", fontWeight: 300 }}
                >
                  {t(item.desc)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
